const OPPOSITE = { left: 'right', right: 'left', top: 'bottom', bottom: 'top' };
const ARROW_INSET = 12;

function clamp(n, min, max) {
  if (min > max) return (min + max) / 2;
  return Math.max(min, Math.min(max, n));
}

function clampArrow(offset, size) {
  const inset = Math.min(ARROW_INSET, size / 2);
  return clamp(offset, inset, size - inset);
}

function positionFor(placement, anchorRect, bubbleRect, offset) {
  const ax = anchorRect.left + anchorRect.width / 2;
  const ay = anchorRect.top + anchorRect.height / 2;
  switch (placement) {
    case 'left':
      return {
        left: anchorRect.left - offset - bubbleRect.width,
        top: ay - bubbleRect.height / 2,
      };
    case 'right':
      return {
        left: anchorRect.right + offset,
        top: ay - bubbleRect.height / 2,
      };
    case 'top':
      return {
        left: ax - bubbleRect.width / 2,
        top: anchorRect.top - offset - bubbleRect.height,
      };
    case 'bottom':
    default:
      return {
        left: ax - bubbleRect.width / 2,
        top: anchorRect.bottom + offset,
      };
  }
}

function overflowsMainAxis(placement, pos, bubbleRect, viewport, padding) {
  switch (placement) {
    case 'left':
      return pos.left < padding;
    case 'right':
      return pos.left + bubbleRect.width > viewport.width - padding;
    case 'top':
      return pos.top < padding;
    case 'bottom':
      return pos.top + bubbleRect.height > viewport.height - padding;
    default:
      return false;
  }
}

/**
 * Collision-aware tooltip placement. Pure: rect objects in, pixels out.
 * Flip on the preferred axis when it overflows, then clamp on both axes
 * so the bubble stays inside viewport - padding. arrowOffset is relative
 * to the bubble's leading cross-axis edge (top for left/right, left for
 * top/bottom) and is kept inside the bubble.
 */
export function computeTooltipPosition({
  anchorRect,
  bubbleRect,
  viewport,
  placement = 'top',
  offset = 10,
  padding = 8,
}) {
  let side = OPPOSITE[placement] ? placement : 'top';
  let pos = positionFor(side, anchorRect, bubbleRect, offset);

  if (overflowsMainAxis(side, pos, bubbleRect, viewport, padding)) {
    side = OPPOSITE[side];
    pos = positionFor(side, anchorRect, bubbleRect, offset);
  }

  const minLeft = padding;
  const maxLeft = viewport.width - padding - bubbleRect.width;
  const minTop = padding;
  const maxTop = viewport.height - padding - bubbleRect.height;

  const left = clamp(pos.left, minLeft, maxLeft);
  const top = clamp(pos.top, minTop, maxTop);

  const arrowOffset = (side === 'left' || side === 'right')
    ? clampArrow(anchorRect.top + anchorRect.height / 2 - top, bubbleRect.height)
    : clampArrow(anchorRect.left + anchorRect.width / 2 - left, bubbleRect.width);

  return { top, left, placement: side, arrowOffset };
}
